const staticHeader = {
  el: {
    hamburger: null as HTMLElement | null,
    nav: null as HTMLElement | null,
  },
  selectors: {
    nav: '.static-header__nav',
    logo: '.static-header__logo',
    hamburger: '.static-header .header__hamburgerbutton',
    root: '.static-header',
  },

  init() {
    this.el.hamburger = document.querySelector(this.selectors.hamburger) as HTMLButtonElement
    this.el.nav = document.querySelector(this.selectors.nav) as HTMLElement

    if (this.el.hamburger) {
      this.el.hamburger.removeEventListener('click', this.hamburgerClickEvent.bind(this))
      this.el.hamburger.addEventListener('click', this.hamburgerClickEvent.bind(this))
    }
  },

  hamburgerClickEvent(e: Event) {
    e.stopImmediatePropagation()

    const target = e.currentTarget as HTMLButtonElement
    target.classList.toggle('active')

    const parent = target.closest<HTMLElement>('.header__inner, .static-header')
    if (parent) {
      parent.querySelector<SVGElement>('.hamburger-icon')?.classList.toggle('hamburger-icon--clicked')
      parent.querySelector<HTMLElement>('.mobile-navigation')?.classList.toggle('active')
    }

    this.el.nav.classList.toggle('static-header__nav--active')

    e.stopPropagation()
  },
}

export default staticHeader
